import React from 'react'
import { Link } from 'react-router-dom'

function SellerDashboardBreadCrumb() {
    return (
        <Link to="/seller/dashboard">Dashboard</Link>
    )
}

export default SellerDashboardBreadCrumb